module.exports = __webpack_public_path__ + "static/media/rome.d0728851.jpeg";